interface Props {
  rating: number;
  showValue?: boolean;
}

export default function RatingStars({ rating, showValue = true }: Props) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return (
    <span className="inline-flex items-center gap-1">
      <span className="flex items-center text-primary-500" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => {
          let name = "ri-star-line";
          if (i < full) name = "ri-star-fill";
          else if (i === full && half) name = "ri-star-half-fill";
          return <i key={i} className={`${name} text-sm`} />;
        })}
      </span>
      {showValue && (
        <span className="text-xs font-semibold text-foreground-700">{rating.toFixed(1)}</span>
      )}
      <span className="sr-only">评分 {rating.toFixed(1)} 分</span>
    </span>
  );
}